const FETCH_NON_BILLED_SESSIONS_REPORT = 'fetch_nonBilledSessionsReport';
const FETCH_NON_BILLED_SESSIONS_REPORT_CSV = 'fetch_nonBilledSessionsReport_csv';

export default {
    FETCH_NON_BILLED_SESSIONS_REPORT,
    FETCH_NON_BILLED_SESSIONS_REPORT_CSV,
};
